import type { HTMLAttributes, ReactNode } from 'react'

/**
 * Status meanings, each with its own color:
 * - neutral: Draft, Not Started, Archived.
 * - info: Sent, Viewed, In Review.
 * - pending: Awaiting Signature, Awaiting Approval. Amber, never the old Draft orange.
 * - success: Signed, Approved, Published.
 * - danger: Expired, Declined, Failed.
 */
export type StatusTone = 'neutral' | 'info' | 'pending' | 'success' | 'danger'

export type StatusBadgeProps = Omit<HTMLAttributes<HTMLSpanElement>, 'children'> & {
  tone?: StatusTone
  /** Pass the label in Title Case. The badge does not change letter case. */
  children: ReactNode
}

export function StatusBadge({ tone = 'neutral', children, className = '', ...props }: StatusBadgeProps) {
  return (
    <span {...props} className={['ui-status-badge', `ui-status-badge--${tone}`, className].filter(Boolean).join(' ')}>
      {children}
    </span>
  )
}
